module.exports = __webpack_public_path__ + "img/cross.bdbf237e.svg";